import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=29482a71&scoped=true&"
import script from "./SocialIcons.vue?vue&type=script&lang=js&"
export * from "./SocialIcons.vue?vue&type=script&lang=js&"
import style0 from "./SocialIcons.vue?vue&type=style&index=0&id=29482a71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29482a71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29482a71')) {
      api.createRecord('29482a71', component.options)
    } else {
      api.reload('29482a71', component.options)
    }
    module.hot.accept("./SocialIcons.vue?vue&type=template&id=29482a71&scoped=true&", function () {
      api.rerender('29482a71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/contact/SocialIcons.vue"
export default component.exports